import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import { OperatorRowData } from '../useOperatorsTable'
import { ActionsTd, Td } from '../styled-components'

interface OperatorRowProps {
  row: OperatorRowData
  isSubmitting: boolean
  forceStopLabel: string
}

const OperatorRow = ({ row, isSubmitting, forceStopLabel }: OperatorRowProps) => (
  <tr>
    <Td>{row.name}</Td>
    <Td>{row.department}</Td>
    <Td>{row.startTime}</Td>
    <ActionsTd>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton id={`break-${row.breakId}-force-stop-btn`} disabled={isSubmitting} onClick={row.onForceStop}>
        {forceStopLabel}
      </SDButton>
    </ActionsTd>
  </tr>
)

export default OperatorRow
